import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const UserIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={svgWidth}
            height={svgHeight}
            fill="none"
            viewBox="0 0 24 24"
            {...restProps}
        >
            <path
                fill={color}
                d="M12.001 11.305a5.052 5.052 0 100-10.104 5.052 5.052 0 000 10.104z"
            ></path>
            <path
                fill={color}
                fillRule="evenodd"
                d="M2.006 21.802c-.054.55.399.998.951.998h18.088c.552 0 1.005-.449.95-.998-.483-4.899-4.492-8.767-9.452-9.031l1.427 7.305a.6.6 0 01-.156.528v.012l-1.464 1.512a.492.492 0 01-.696 0l-1.452-1.512a.636.636 0 01-.156-.54l1.488-7.308.054-.003c-5.02.203-9.093 4.096-9.582 9.037z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
};

export default React.memo(UserIcon);
